import useField from './useField';
import { NameProvider } from './NameContext';
const subscription = {};
function Field({ name, validate, children }) {
    useField(name, { validate, subscription });
    return (React.createElement(NameProvider, { value: name }, children));
}
export default Field;
